import { Enums } from "@/helpers/enums";
import { Ajax, MethodType } from "@/helpers/web";

export const MeetingFileService = {
    Get(id, callback, wait) {
        return Ajax.Api(MethodType.Get, `${Enums.SERVICE.MEETING_FILE}/${id}`, null, wait).then((data) => {
            if (callback) { callback(data); }
            return data;
        });
    },
    List(meetingId, callback, wait) {
        return Ajax.Api(MethodType.Get, `${Enums.SERVICE.MEETING_FILE}/meeting/${meetingId}`, {}, wait).then((data) => {
            if (callback) { callback(data); }
            return data;
        });
    },
    Save(j, callback, wait) {
        return Ajax.Api(MethodType.Post, Enums.SERVICE.MEETING_FILE, j, wait).then((data) => {
            if (callback) { callback(data); }
            return data;
        });
    },
    Delete(id, callback, wait) {
        return Ajax.Api(MethodType.Delete, `${Enums.SERVICE.MEETING_FILE}/${id}`, {}, wait).then((data) => {
            if (callback) { callback(data); }
            return data;
        });
    }
};